module.exports = __webpack_public_path__ + "static/media/img6.720d1880.jpg";